export const getRegisterDirectives = async (bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-registration/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};
export const getRegisterDirectivesByStakeholder = async (bearer: string, stakeholder_id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-registration/by-stakeholder/?stakeholder_id=${stakeholder_id}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};

export const getRegisterDirectivesByProsecutor = async (bearer: string, prosecutor_user_id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-registration/by-prosecutor/?prosecutor_user_id=${prosecutor_user_id}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Register Directives by prosecutor");
    }
    return response.json();
};
export const getRegisterDirective = async (bearer: string, id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-registration/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};

export const createRegisterDirective = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-registration/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateRegisterDirective = async (bearer: string, id: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-registration/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to update Legal Advisory request");
    }
    return response.json();
};


export const createRegisterDirectiveFeedback = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const createRegisterDirectiveRespondbackFeedback = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-respond-back-feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};


export const createRegisterDirectiveRemark = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-remarks/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const createRegisterDirectiveProsecutorAssignment = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-prosecutor-assignments/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateRegisterDirectiveProsecutorAssignment = async (bearer: string, id: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-prosecutor-assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const createRegisterDirectiveAdditionalInfo = async (bearer: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-additional-info/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateRegisterDirectiveAdditionalInfo = async (bearer: string, id: string, data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}directive_registration/directive-additional-info/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

